import { isSessionExpired } from '@/common/utils/SessionTimeout';

export default async function isLogin({ next, store }) {
  const isAuthenticated = store.getters['expert/getIsAuthenticated'];

  if (!isAuthenticated) {
    return next({
      name: 'ExpertLogin'
    });
  }

  if (isSessionExpired()) {
    await store.dispatch('expert/expireSession');
    return next({
      name: 'ExpertLogin',
      query: { expired: '1' }
    });
  }

  return next();
}
